function convertTo12HourFormat(time) {
  var parts = time.split(":");
  var hours = parseInt(parts[0]);
  var minutes = parseInt(parts[1]);
  var suffix = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12;
  var formattedTime =
    hours.toString().padStart(2, "0") +
    ":" +
    minutes.toString().padStart(2, "0") +
    " " +
    suffix;
  return formattedTime;
}
function formatCurrency(number) {
  number = Number(number);
  // const formattedCurrency = number.toLocaleString('en-PK', {
  //   style: 'currency',
  //   currency: 'PKR'
  // })
  // Ensure the input is a valid number
  if (typeof number !== "number") return "0 PKR";
  const integerPart = Math.floor(number);
  const formattedIntegerPart = integerPart
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return `${formattedIntegerPart} PKR`;
}
function formatPhoneNumberPK(phoneNumber) {
  phoneNumber = phoneNumber.replace(/\D/g, "");
  if (phoneNumber === "" || phoneNumber.length < 10) return phoneNumber;
  phoneNumber = "+92 " + phoneNumber.substr(1, 2) + "-" + phoneNumber.substr(3);
  return phoneNumber;
}
function generateRandomAlphanumeric() {
  const alphanumericCharacters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let randomString = "";

  for (let i = 0; i < 6; i++) {
    const randomIndex = Math.floor(
      Math.random() * alphanumericCharacters.length,
    );
    randomString += alphanumericCharacters.charAt(randomIndex);
  }

  return randomString;
}

const capitalizeTranslated = (value, t) => {
  if (value === null || value === undefined) return "";

  // Convert value to string first
  let str = String(value);

  // If t is a function, translate it
  if (typeof t === "function") {
    str = String(t(value));
  }

  // Capitalize first letter, rest lowercase
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

// 43,14,45 dates helper function
const isSunday = (d) => d.day() === 0;

const getNextValidDate = (date) => {
  let d = date.clone();
  while (isSunday(d)) {
    d = d.add(1, "day");
  }
  return d;
};

// 👉 working days add (Sunday skip)
const addBusinessDays = (date, days) => {
  let d = date.clone();
  let added = 0;

  while (added < days) {
    d = d.add(1, "day");
    if (!isSunday(d)) added++;
  }

  return d;
};

const addDaysWithSundayCheck = (date, days) => {
  let d = date.clone().add(days, "day");

  // ✅ ONLY final day check
  if (isSunday(d)) {
    d = d.add(1, "day");
  }

  return d;
};

// const generateNormalDates = (startDate, count) => {
//   if (!startDate) return [];

//   const gaps = [0, 3, 14, 44];
//   const AUTO_LIMIT = 4; // ✅ only 4 sessions

//   const dates = [];
//   let current = getNextValidDate(startDate.clone());

//   for (let i = 0; i < count; i++) {
//     if (i >= AUTO_LIMIT) {
//       dates.push(null); // ❗ remaining blank
//       continue;
//     }

//     if (i === 0) {
//       dates.push(current.clone());
//     } else {
//       current = addDaysWithSundayCheck(current, gaps[i]);

//       dates.push(
//         current.clone().hour(startDate.hour()).minute(startDate.minute()),
//       );
//     }
//   }

//   return dates;
// };

// const generatePRPDates = (lastFueDate, count) => {
//   if (!lastFueDate) return [];

//   const gaps = [3, 14, 44];
//   const AUTO_LIMIT = 3; // ❗ only 3 PRP sessions

//   const dates = [];
//   let current = getNextValidDate(lastFueDate.clone());

//   for (let i = 0; i < count; i++) {
//     if (i >= AUTO_LIMIT) {
//       dates.push(null); // ❗ rest blank
//       continue;
//     }

//     current = addDaysWithSundayCheck(current, gaps[i]);

//     dates.push(
//       current.clone().hour(lastFueDate.hour()).minute(lastFueDate.minute()),
//     );
//   }

//   return dates;
// };

const generateNormalDates = (startDate, count) => {
  if (!startDate) return [];

  const gaps = [0, 3, 14, 44];
  const AUTO_LIMIT = 4;

  const dates = [];

  for (let i = 0; i < count; i++) {
    if (i >= AUTO_LIMIT) {
      dates.push(null);
      continue;
    }

    // ✅ har session directly selected date se calculate hoga
    let calculatedDate = addDaysWithSundayCheck(startDate.clone(), gaps[i]);

    dates.push(
      calculatedDate.clone().hour(startDate.hour()).minute(startDate.minute()),
    );
  }

  return dates;
};

const generatePRPDates = (lastFueDate, count) => {
  if (!lastFueDate) return [];

  const gaps = [3, 14, 44];
  const AUTO_LIMIT = 3;

  const dates = [];

  for (let i = 0; i < count; i++) {
    if (i >= AUTO_LIMIT) {
      dates.push(null);
      continue;
    }

    // ✅ har PRP session directly FUE selected date se calculate hoga
    let calculatedDate = addDaysWithSundayCheck(lastFueDate.clone(), gaps[i]);

    dates.push(
      calculatedDate
        .clone()
        .hour(lastFueDate.hour())
        .minute(lastFueDate.minute()),
    );
  }

  return dates;
};

const formatLabel = (key) => {
  return key
    .substring(2)
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .trim();
};

const toCapitalize = (str) => {
  if (!str) return "-";
  const normalized = str.normalize("NFKD").replace(/[^\x00-\x7F]/g, (char) => {
    const base = char.normalize("NFKD")[0];
    return base || char;
  });
  return normalized.charAt(0).toUpperCase() + normalized.slice(1).toLowerCase();
};

const isImageFile = (file) => {
  if (file.type) return file.type.startsWith("image/");
  return /\.(jpg|jpeg|png|gif|webp)$/i.test(file.url || file.name);
};

const getFileNameFromUrl = (url) => {
  try {
    const pathname = new URL(url).pathname;
    return pathname.substring(pathname.lastIndexOf("/") + 1);
  } catch {
    return url.substring(url.lastIndexOf("/") + 1);
  }
};

const formatCompactAmount = (amount) => {
  const num = Number(amount);
  if (isNaN(num)) return "0";

  return new Intl.NumberFormat("en-US", {
    notation: "compact",
    compactDisplay: "short",
    maximumFractionDigits: 1, // 1500 becomes 1.5k instead of 2k
  }).format(num); // Converts 'K' to 'k' or 'M' to 'm'
};

export {
  convertTo12HourFormat,
  formatCurrency,
  formatPhoneNumberPK,
  generateRandomAlphanumeric,
  capitalizeTranslated,
  getNextValidDate,
  generateNormalDates,
  generatePRPDates,
  formatLabel,
  toCapitalize,
  addDaysWithSundayCheck,
  isImageFile,
  getFileNameFromUrl,
  formatCompactAmount,
};
